var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _path40, _g40, _path41, _g41, _path42, _g42, _path43, _g43, _path44, _g44, _path45, _g45, _path46, _g46, _path47, _g47, _path48, _g48, _path49, _g49, _path50, _g50, _path51, _path52, _path53, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 270,
    width: 19,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.299 295.849C168.576 298.04 167.024 300.047 164.825 300.266C161.226 300.623 157.615 300.85 154 300.947C151.791 301.006 150 299.209 150 297V275C150 272.791 151.791 271.007 153.999 270.933C156.358 270.855 158.714 270.706 161.064 270.489C163.264 270.285 165.264 271.831 165.541 274.022L168.299 295.849Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.299 295.849C168.576 298.04 167.024 300.047 164.825 300.266C161.226 300.623 157.615 300.85 154 300.947C151.791 301.006 150 299.209 150 297V275C150 272.791 151.791 271.007 153.999 270.933C156.358 270.855 158.714 270.706 161.064 270.489C163.264 270.285 165.264 271.831 165.541 274.022L168.299 295.849Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 268,
    width: 22,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.309 292.413C186.858 294.553 185.57 296.738 183.416 297.23C179.89 298.036 176.336 298.714 172.761 299.263C170.578 299.598 168.576 298.04 168.299 295.849L165.541 274.022C165.264 271.831 166.818 269.836 168.999 269.486C171.33 269.113 173.648 268.67 175.953 268.16C178.109 267.682 180.288 268.965 180.838 271.104L186.309 292.413Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.309 292.413C186.858 294.553 185.57 296.738 183.416 297.23C179.89 298.036 176.336 298.714 172.761 299.263C170.578 299.598 168.576 298.04 168.299 295.849L165.541 274.022C165.264 271.831 166.818 269.836 168.999 269.486C171.33 269.113 173.648 268.67 175.953 268.16C178.109 267.682 180.288 268.965 180.838 271.104L186.309 292.413Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 263,
    width: 25,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.746 286.747C204.559 288.801 203.555 291.131 201.48 291.889C198.083 293.131 194.642 294.249 191.164 295.241C189.04 295.847 186.858 294.553 186.309 292.413L180.838 271.104C180.288 268.965 181.58 266.791 183.7 266.171C185.965 265.508 188.21 264.779 190.432 263.983C192.512 263.239 194.834 264.238 195.647 266.292L203.746 286.747Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.746 286.747C204.559 288.801 203.555 291.131 201.48 291.889C198.083 293.131 194.642 294.249 191.164 295.241C189.04 295.847 186.858 294.553 186.309 292.413L180.838 271.104C180.288 268.965 181.58 266.791 183.7 266.171C185.965 265.508 188.21 264.779 190.432 263.983C192.512 263.239 194.834 264.238 195.647 266.292L203.746 286.747Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 257,
    width: 26,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.336 278.941C221.4 280.877 220.696 283.314 218.733 284.326C215.518 285.983 212.244 287.524 208.918 288.945C206.886 289.812 204.559 288.801 203.746 286.747L195.647 266.292C194.834 264.238 195.843 261.92 197.869 261.039C200.033 260.098 202.169 259.092 204.274 258.025C206.244 257.026 208.673 257.726 209.737 259.662L220.336 278.941Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.336 278.941C221.4 280.877 220.696 283.314 218.733 284.326C215.518 285.983 212.244 287.524 208.918 288.945C206.886 289.812 204.559 288.801 203.746 286.747L195.647 266.292C194.834 264.238 195.843 261.92 197.869 261.039C200.033 260.098 202.169 259.092 204.274 258.025C206.244 257.026 208.673 257.726 209.737 259.662L220.336 278.941Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 249,
    width: 28,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.817 269.116C237.115 270.904 236.722 273.41 234.901 274.66C231.919 276.707 228.864 278.646 225.742 280.472C223.835 281.588 221.4 280.877 220.336 278.941L209.737 259.662C208.673 257.726 209.384 255.3 211.283 254.172C213.312 252.966 215.305 251.702 217.26 250.379C219.089 249.141 221.587 249.531 222.885 251.318L235.817 269.116Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.817 269.116C237.115 270.904 236.722 273.41 234.901 274.66C231.919 276.707 228.864 278.646 225.742 280.472C223.835 281.588 221.4 280.877 220.336 278.941L209.737 259.662C208.673 257.726 209.384 255.3 211.283 254.172C213.312 252.966 215.305 251.702 217.26 250.379C219.089 249.141 221.587 249.531 222.885 251.318L235.817 269.116Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 240,
    width: 30,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.944 257.374C251.456 258.984 251.38 261.52 249.73 262.989C247.028 265.393 244.241 267.7 241.372 269.903C239.62 271.249 237.115 270.848 235.817 269.061L222.885 251.262C221.587 249.475 221.988 246.979 223.731 245.622C225.593 244.172 227.411 242.667 229.185 241.11C230.845 239.652 233.372 239.726 234.884 241.336L249.944 257.374Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.944 257.374C251.456 258.984 251.38 261.52 249.73 262.989C247.028 265.393 244.241 267.7 241.372 269.903C239.62 271.249 237.115 270.848 235.817 269.061L222.885 251.262C221.587 249.475 221.988 246.979 223.731 245.622C225.593 244.172 227.411 242.667 229.185 241.11C230.845 239.652 233.372 239.726 234.884 241.336L249.944 257.374Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 229,
    width: 31,
    height: 30
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.495 244.008C264.197 245.416 264.44 247.942 262.987 249.606C260.608 252.33 258.131 254.968 255.561 257.513C253.992 259.068 251.456 258.984 249.944 257.374L234.884 241.336C233.372 239.726 233.456 237.199 235.015 235.634C236.681 233.962 238.297 232.242 239.861 230.474C241.325 228.82 243.841 228.577 245.544 229.985L262.495 244.008Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.495 244.008C264.197 245.416 264.44 247.942 262.987 249.606C260.608 252.33 258.131 254.968 255.561 257.513C253.992 259.068 251.456 258.984 249.944 257.374L234.884 241.336C233.372 239.726 233.456 237.199 235.015 235.634C236.681 233.962 238.297 232.242 239.861 230.474C241.325 228.82 243.841 228.577 245.544 229.985L262.495 244.008Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 244,
    y: 216,
    width: 32,
    height: 29
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273.272 229.175C275.137 230.359 275.694 232.834 274.461 234.667C272.442 237.668 270.316 240.595 268.085 243.442C266.723 245.181 264.197 245.416 262.495 244.008L245.544 229.985C243.841 228.577 243.609 226.059 244.959 224.311C246.402 222.444 247.79 220.534 249.12 218.585C250.365 216.76 252.831 216.203 254.697 217.387L273.272 229.175Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.272 229.175C275.137 230.359 275.694 232.834 274.461 234.667C272.442 237.668 270.316 240.595 268.085 243.442C266.723 245.181 264.197 245.416 262.495 244.008L245.544 229.985C243.841 228.577 243.609 226.059 244.959 224.311C246.402 222.444 247.79 220.534 249.12 218.585C250.365 216.76 252.831 216.203 254.697 217.387L273.272 229.175Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 203,
    width: 33,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.105 213.108C284.104 214.049 284.966 216.434 283.973 218.407C282.346 221.638 280.603 224.808 278.747 227.913C277.614 229.809 275.137 230.359 273.272 229.175L254.697 217.387C252.831 216.203 252.285 213.735 253.406 211.831C254.603 209.797 255.741 207.729 256.816 205.628C257.823 203.662 260.2 202.8 262.199 203.741L282.105 213.108Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.105 213.108C284.104 214.049 284.966 216.434 283.973 218.407C282.346 221.638 280.603 224.808 278.747 227.913C277.614 229.809 275.137 230.359 273.272 229.175L254.697 217.387C252.831 216.203 252.285 213.735 253.406 211.831C254.603 209.797 255.741 207.729 256.816 205.628C257.823 203.662 260.2 202.8 262.199 203.741L282.105 213.108Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 259,
    y: 189,
    width: 33,
    height: 25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.854 196.061C290.955 196.743 292.11 199.002 291.372 201.084C290.163 204.493 288.831 207.857 287.379 211.17C286.492 213.193 284.104 214.049 282.105 213.108L262.199 203.741C260.2 202.8 259.348 200.42 260.222 198.391C261.155 196.223 262.024 194.028 262.828 191.809C263.58 189.732 265.83 188.58 267.931 189.262L288.854 196.061Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.854 196.061C290.955 196.743 292.11 199.002 291.372 201.084C290.163 204.493 288.831 207.857 287.379 211.17C286.492 213.193 284.104 214.049 282.105 213.108L262.199 203.741C260.2 202.8 259.348 200.42 260.222 198.391C261.155 196.223 262.024 194.028 262.828 191.809C263.58 189.732 265.83 188.58 267.931 189.262L288.854 196.061Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 174,
    width: 32,
    height: 23
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M293.414 178.302C295.584 178.716 297.013 180.812 296.541 182.97C295.769 186.504 294.869 190.008 293.844 193.477C293.217 195.595 290.955 196.743 288.854 196.061L267.931 189.262C265.83 188.58 264.687 186.325 265.299 184.202C265.953 181.935 266.54 179.648 267.06 177.346C267.546 175.191 269.634 173.766 271.804 174.18L293.414 178.302Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.414 178.302C295.584 178.716 297.013 180.812 296.541 182.97C295.769 186.504 294.869 190.008 293.844 193.477C293.217 195.595 290.955 196.743 288.854 196.061L267.931 189.262C265.83 188.58 264.687 186.325 265.299 184.202C265.953 181.935 266.54 179.648 267.06 177.346C267.546 175.191 269.634 173.766 271.804 174.18L293.414 178.302Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 158,
    width: 32,
    height: 21
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M295.712 160.112C297.917 160.25 299.597 162.151 299.4 164.351C299.076 167.954 298.623 171.543 298.04 175.113C297.684 177.293 295.584 178.716 293.414 178.302L271.804 174.18C269.634 173.766 268.217 171.672 268.558 169.489C268.923 167.157 269.219 164.816 269.446 162.466C269.658 160.267 271.551 158.592 273.755 158.73L295.712 160.112Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.712 160.112C297.917 160.25 299.597 162.151 299.4 164.351C299.076 167.954 298.623 171.543 298.04 175.113C297.684 177.293 295.584 178.716 293.414 178.302L271.804 174.18C269.634 173.766 268.217 171.672 268.558 169.489C268.923 167.157 269.219 164.816 269.446 162.466C269.658 160.267 271.551 158.592 273.755 158.73L295.712 160.112Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 141,
    width: 32,
    height: 20
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M295.712 141.777C297.917 141.638 299.822 143.313 299.902 145.521C300.033 149.135 300.033 152.753 299.902 156.368C299.822 158.576 297.917 160.25 295.712 160.112L273.755 158.73C271.551 158.592 269.883 156.692 269.948 154.484C270.017 152.125 270.017 149.764 269.948 147.405C269.883 145.197 271.551 143.297 273.755 143.158L295.712 141.777Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.712 141.777C297.917 141.638 299.822 143.313 299.902 145.521C300.033 149.135 300.033 152.753 299.902 156.368C299.822 158.576 297.917 160.25 295.712 160.112L273.755 158.73C271.551 158.592 269.883 156.692 269.948 154.484C270.017 152.125 270.017 149.764 269.948 147.405C269.883 145.197 271.551 143.297 273.755 143.158L295.712 141.777Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 123,
    width: 32,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M293.414 123.587C295.584 123.173 297.684 124.596 298.04 126.776C298.623 130.345 299.076 133.935 299.4 137.537C299.597 139.738 297.917 141.638 295.712 141.777L273.755 143.158C271.551 143.297 269.658 141.621 269.446 139.422C269.219 137.073 268.923 134.731 268.558 132.399C268.217 130.217 269.634 128.123 271.804 127.709L293.414 123.587Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.414 123.587C295.584 123.173 297.684 124.596 298.04 126.776C298.623 130.345 299.076 133.935 299.4 137.537C299.597 139.738 297.917 141.638 295.712 141.777L273.755 143.158C271.551 143.297 269.658 141.621 269.446 139.422C269.219 137.073 268.923 134.731 268.558 132.399C268.217 130.217 269.634 128.123 271.804 127.709L293.414 123.587Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 105,
    width: 32,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M288.854 105.828C290.955 105.145 293.217 106.294 293.844 108.412C294.869 111.881 295.769 115.385 296.541 118.918C297.013 121.077 295.584 123.173 293.414 123.587L271.804 127.709C269.634 128.123 267.546 126.698 267.06 124.543C266.54 122.24 265.953 119.954 265.299 117.686C264.687 115.564 265.83 113.309 267.931 112.626L288.854 105.828Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.854 105.828C290.955 105.145 293.217 106.294 293.844 108.412C294.869 111.881 295.769 115.385 296.541 118.918C297.013 121.077 295.584 123.173 293.414 123.587L271.804 127.709C269.634 128.123 267.546 126.698 267.06 124.543C266.54 122.24 265.953 119.954 265.299 117.686C264.687 115.564 265.83 113.309 267.931 112.626L288.854 105.828Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 259,
    y: 88,
    width: 33,
    height: 25
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M282.105 88.7806C284.104 87.84 286.492 88.6958 287.379 90.719C288.831 94.0316 290.163 97.3956 291.372 100.804C292.11 102.887 290.955 105.145 288.854 105.828L267.931 112.626C265.83 113.309 263.58 112.156 262.828 110.079C262.024 107.86 261.155 105.666 260.222 103.498C259.348 101.469 260.2 99.0883 262.199 98.1477L282.105 88.7806Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.105 88.7806C284.104 87.84 286.492 88.6958 287.379 90.719C288.831 94.0316 290.163 97.3956 291.372 100.804C292.11 102.887 290.955 105.145 288.854 105.828L267.931 112.626C265.83 113.309 263.58 112.156 262.828 110.079C262.024 107.86 261.155 105.666 260.222 103.498C259.348 101.469 260.2 99.0883 262.199 98.1477L282.105 88.7806Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 72,
    width: 33,
    height: 27
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.272 72.7136C275.137 71.5299 277.614 72.0797 278.747 73.9758C280.603 77.0803 282.346 80.2508 283.973 83.4813C284.966 85.4544 284.104 87.84 282.105 88.7806L262.199 98.1477C260.2 99.0883 257.823 98.227 256.816 96.2606C255.741 94.1598 254.603 92.0912 253.406 90.0575C252.285 88.1539 252.831 85.6855 254.697 84.5018L273.272 72.7136Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.272 72.7136C275.137 71.5299 277.614 72.0797 278.747 73.9758C280.603 77.0803 282.346 80.2508 283.973 83.4813C284.966 85.4544 284.104 87.84 282.105 88.7806L262.199 98.1477C260.2 99.0883 257.823 98.227 256.816 96.2606C255.741 94.1598 254.603 92.0912 253.406 90.0575C252.285 88.1539 252.831 85.6855 254.697 84.5018L273.272 72.7136Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 244,
    y: 56,
    width: 32,
    height: 30
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.495 57.8804C264.197 56.4723 266.723 56.7073 268.085 58.4464C270.316 61.2938 272.442 64.2209 274.461 67.222C275.694 69.055 275.137 71.5299 273.272 72.7136L254.697 84.5018C252.831 85.6855 250.365 85.1289 249.12 83.3042C247.79 81.3548 246.402 79.445 244.959 77.5774C243.609 75.8293 243.841 73.3119 245.544 71.9038L262.495 57.8804Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.495 57.8804C264.197 56.4723 266.723 56.7073 268.085 58.4464C270.316 61.2938 272.442 64.2209 274.461 67.222C275.694 69.055 275.137 71.5299 273.272 72.7136L254.697 84.5018C252.831 85.6855 250.365 85.1289 249.12 83.3042C247.79 81.3548 246.402 79.445 244.959 77.5774C243.609 75.8293 243.841 73.3119 245.544 71.9038L262.495 57.8804Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 43,
    width: 31,
    height: 30
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M249.944 44.5149C251.456 42.9045 253.992 42.8211 255.561 44.3758C258.131 46.9212 260.608 49.5586 262.987 52.2831C264.44 53.9471 264.197 56.4723 262.495 57.8804L245.544 71.9038C243.841 73.3119 241.325 73.0688 239.861 71.4145C238.297 69.6472 236.681 67.9264 235.015 66.2544C233.456 64.6893 233.372 62.1626 234.884 60.5522L249.944 44.5149Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.944 44.5149C251.456 42.9045 253.992 42.8211 255.561 44.3758C258.131 46.9212 260.608 49.5586 262.987 52.2831C264.44 53.9471 264.197 56.4723 262.495 57.8804L245.544 71.9038C243.841 73.3119 241.325 73.0688 239.861 71.4145C238.297 69.6472 236.681 67.9264 235.015 66.2544C233.456 64.6893 233.372 62.1626 234.884 60.5522L249.944 44.5149Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 31,
    width: 30,
    height: 31
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.817 32.8279C237.115 31.0406 239.62 30.6401 241.372 31.9858C244.241 34.189 247.028 36.4953 249.73 38.9001C251.38 40.3688 251.456 42.9045 249.944 44.5149L234.884 60.5522C233.372 62.1626 230.845 62.2368 229.185 60.779C227.411 59.2217 225.593 57.717 223.731 56.2669C221.988 54.9096 221.587 52.4135 222.885 50.6262L235.817 32.8279Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.817 32.8279C237.115 31.0406 239.62 30.6401 241.372 31.9858C244.241 34.189 247.028 36.4953 249.73 38.9001C251.38 40.3688 251.456 42.9045 249.944 44.5149L234.884 60.5522C233.372 62.1626 230.845 62.2368 229.185 60.779C227.411 59.2217 225.593 57.717 223.731 56.2669C221.988 54.9096 221.587 52.4135 222.885 50.6262L235.817 32.8279Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 20,
    width: 28,
    height: 33
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.336 23.0036C221.4 21.0677 223.835 20.3564 225.742 21.4719C228.864 23.2982 231.919 25.2369 234.901 27.2841C236.722 28.5345 237.115 31.0406 235.817 32.8279L222.885 50.6262C221.587 52.4135 219.089 52.8037 217.26 51.5655C215.305 50.2427 213.312 48.9779 211.283 47.7726C209.384 46.6444 208.673 44.2182 209.737 42.2823L220.336 23.0036Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.336 23.0036C221.4 21.0677 223.835 20.3564 225.742 21.4719C228.864 23.2982 231.919 25.2369 234.901 27.2841C236.722 28.5345 237.115 31.0406 235.817 32.8279L222.885 50.6262C221.587 52.4135 219.089 52.8037 217.26 51.5655C215.305 50.2427 213.312 48.9779 211.283 47.7726C209.384 46.6444 208.673 44.2182 209.737 42.2823L220.336 23.0036Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 12,
    width: 26,
    height: 33
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M203.746 15.197C204.559 13.143 206.886 12.132 208.918 12.9998C212.244 14.4204 215.518 15.961 218.733 17.6183C220.696 18.6306 221.4 21.0677 220.336 23.0036L209.737 42.2823C208.673 44.2182 206.244 44.9185 204.274 43.9193C202.169 42.8519 200.033 41.8468 197.869 40.9054C195.843 40.0241 194.834 37.7061 195.647 35.652L203.746 15.197Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.746 15.197C204.559 13.143 206.886 12.132 208.918 12.9998C212.244 14.4204 215.518 15.961 218.733 17.6183C220.696 18.6306 221.4 21.0677 220.336 23.0036L209.737 42.2823C208.673 44.2182 206.244 44.9185 204.274 43.9193C202.169 42.8519 200.033 41.8468 197.869 40.9054C195.843 40.0241 194.834 37.7061 195.647 35.652L203.746 15.197Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 6,
    width: 25,
    height: 33
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M186.309 9.53118C186.858 7.39144 189.04 6.09691 191.164 6.70315C194.642 7.69573 198.083 8.81377 201.48 10.0551C203.555 10.8133 204.559 13.143 203.746 15.197L195.647 35.652C194.834 37.7061 192.512 38.7052 190.432 37.9609C188.21 37.1657 185.965 36.4363 183.7 35.7735C181.58 35.1531 180.288 32.9798 180.838 30.84L186.309 9.53118Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.309 9.53118C186.858 7.39144 189.04 6.09691 191.164 6.70315C194.642 7.69573 198.083 8.81377 201.48 10.0551C203.555 10.8133 204.559 13.143 203.746 15.197L195.647 35.652C194.834 37.7061 192.512 38.7052 190.432 37.9609C188.21 37.1657 185.965 36.4363 183.7 35.7735C181.58 35.1531 180.288 32.9798 180.838 30.84L186.309 9.53118Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 2,
    width: 22,
    height: 32
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168.299 6.09558C168.576 3.90387 170.578 2.3461 172.761 2.6813C176.336 3.23016 179.89 3.90811 183.416 4.71387C185.57 5.20602 186.858 7.39145 186.309 9.53119L180.838 30.84C180.288 32.9798 178.109 34.2621 175.953 33.7843C173.648 33.2739 171.33 32.8316 168.999 32.4579C166.818 32.1082 165.264 30.1138 165.541 27.9221L168.299 6.09558Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.299 6.09558C168.576 3.90387 170.578 2.3461 172.761 2.6813C176.336 3.23016 179.89 3.90811 183.416 4.71387C185.57 5.20602 186.858 7.39145 186.309 9.53119L180.838 30.84C180.288 32.9798 178.109 34.2621 175.953 33.7843C173.648 33.2739 171.33 32.8316 168.999 32.4579C166.818 32.1082 165.264 30.1138 165.541 27.9221L168.299 6.09558Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 0,
    width: 19,
    height: 32
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150 4.94435C150 2.73521 151.791 0.938756 154 0.997686C157.615 1.09413 161.226 1.3213 164.825 1.67878C167.024 1.8971 168.576 3.90388 168.299 6.09559L165.541 27.9221C165.264 30.1138 163.264 31.6591 161.064 31.4555C158.714 31.2379 156.358 31.0897 153.999 31.011C151.791 30.9374 150 29.1535 150 26.9443V4.94435Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 4.94435C150 2.73521 151.791 0.938756 154 0.997686C157.615 1.09413 161.226 1.3213 164.825 1.67878C167.024 1.8971 168.576 3.90388 168.299 6.09559L165.541 27.9221C165.264 30.1138 163.264 31.6591 161.064 31.4555C158.714 31.2379 156.358 31.0897 153.999 31.011C151.791 30.9374 150 29.1535 150 26.9443V4.94435Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 270,
    width: 19,
    height: 31
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131.701 295.849C131.424 298.04 132.976 300.047 135.175 300.266C138.774 300.623 142.385 300.85 146 300.947C148.209 301.006 150 299.209 150 297V275C150 272.791 148.209 271.007 146.001 270.933C143.642 270.855 141.286 270.706 138.936 270.489C136.736 270.285 134.736 271.831 134.459 274.022L131.701 295.849Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.701 295.849C131.424 298.04 132.976 300.047 135.175 300.266C138.774 300.623 142.385 300.85 146 300.947C148.209 301.006 150 299.209 150 297V275C150 272.791 148.209 271.007 146.001 270.933C143.642 270.855 141.286 270.706 138.936 270.489C136.736 270.285 134.736 271.831 134.459 274.022L131.701 295.849Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 268,
    width: 22,
    height: 32
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.691 292.413C113.142 294.553 114.43 296.738 116.584 297.23C120.11 298.036 123.664 298.714 127.239 299.263C129.422 299.598 131.424 298.04 131.701 295.849L134.459 274.022C134.736 271.831 133.182 269.836 131.001 269.486C128.67 269.113 126.352 268.67 124.047 268.16C121.891 267.682 119.712 268.965 119.162 271.104L113.691 292.413Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.691 292.413C113.142 294.553 114.43 296.738 116.584 297.23C120.11 298.036 123.664 298.714 127.239 299.263C129.422 299.598 131.424 298.04 131.701 295.849L134.459 274.022C134.736 271.831 133.182 269.836 131.001 269.486C128.67 269.113 126.352 268.67 124.047 268.16C121.891 267.682 119.712 268.965 119.162 271.104L113.691 292.413Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 263,
    width: 25,
    height: 33
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2538 286.747C95.4406 288.801 96.4447 291.131 98.5196 291.889C101.917 293.131 105.358 294.249 108.836 295.241C110.96 295.847 113.142 294.553 113.691 292.413L119.162 271.104C119.712 268.965 118.42 266.791 116.3 266.171C114.035 265.508 111.79 264.779 109.568 263.983C107.488 263.239 105.166 264.238 104.353 266.292L96.2538 286.747Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2538 286.747C95.4406 288.801 96.4447 291.131 98.5196 291.889C101.917 293.131 105.358 294.249 108.836 295.241C110.96 295.847 113.142 294.553 113.691 292.413L119.162 271.104C119.712 268.965 118.42 266.791 116.3 266.171C114.035 265.508 111.79 264.779 109.568 263.983C107.488 263.239 105.166 264.238 104.353 266.292L96.2538 286.747Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 257,
    width: 26,
    height: 33
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.664 278.941C78.5997 280.877 79.3039 283.314 81.2674 284.326C84.4823 285.983 87.756 287.524 91.0823 288.945C93.1139 289.812 95.4406 288.801 96.2538 286.747L104.353 266.292C105.166 264.238 104.157 261.92 102.131 261.039C99.967 260.098 97.8311 259.092 95.7262 258.025C93.756 257.026 91.3268 257.726 90.2625 259.662L79.664 278.941Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.664 278.941C78.5997 280.877 79.3039 283.314 81.2674 284.326C84.4823 285.983 87.756 287.524 91.0823 288.945C93.1139 289.812 95.4406 288.801 96.2538 286.747L104.353 266.292C105.166 264.238 104.157 261.92 102.131 261.039C99.967 260.098 97.8311 259.092 95.7262 258.025C93.756 257.026 91.3268 257.726 90.2625 259.662L79.664 278.941Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 249,
    width: 28,
    height: 33
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1834 269.116C62.8849 270.904 63.278 273.41 65.0993 274.66C68.081 276.707 71.1359 278.646 74.2578 280.472C76.1647 281.588 78.5997 280.877 79.664 278.941L90.2626 259.662C91.3268 257.726 90.6164 255.3 88.7171 254.172C86.688 252.966 84.6949 251.702 82.7404 250.379C80.9109 249.141 78.4131 249.531 77.1146 251.318L64.1834 269.116Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1834 269.116C62.8849 270.904 63.278 273.41 65.0993 274.66C68.081 276.707 71.1359 278.646 74.2578 280.472C76.1647 281.588 78.5997 280.877 79.664 278.941L90.2626 259.662C91.3268 257.726 90.6164 255.3 88.7171 254.172C86.688 252.966 84.6949 251.702 82.7404 250.379C80.9109 249.141 78.4131 249.531 77.1146 251.318L64.1834 269.116Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 240,
    width: 30,
    height: 31
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0561 257.374C48.5439 258.984 48.6198 261.52 50.27 262.989C52.9717 265.393 55.7595 267.7 58.6279 269.903C60.3799 271.249 62.8849 270.848 64.1834 269.061L77.1146 251.262C78.4131 249.475 78.0125 246.979 76.2695 245.622C74.4075 244.172 72.5886 242.667 70.8153 241.11C69.1554 239.652 66.6284 239.726 65.1162 241.336L50.0561 257.374Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0561 257.374C48.5439 258.984 48.6198 261.52 50.27 262.989C52.9717 265.393 55.7595 267.7 58.6279 269.903C60.3799 271.249 62.8849 270.848 64.1834 269.061L77.1146 251.262C78.4131 249.475 78.0125 246.979 76.2695 245.622C74.4075 244.172 72.5886 242.667 70.8153 241.11C69.1554 239.652 66.6284 239.726 65.1162 241.336L50.0561 257.374Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 229,
    width: 31,
    height: 30
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5051 244.008C35.8029 245.416 35.5605 247.942 37.0135 249.606C39.3925 252.33 41.8693 254.968 44.4389 257.513C46.0084 259.068 48.5439 258.984 50.0561 257.374L65.1162 241.336C66.6284 239.726 66.5437 237.199 64.9846 235.634C63.319 233.962 61.7031 232.242 60.139 230.474C58.6749 228.82 56.1585 228.577 54.4564 229.985L37.5051 244.008Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5051 244.008C35.8029 245.416 35.5605 247.942 37.0135 249.606C39.3925 252.33 41.8693 254.968 44.4389 257.513C46.0084 259.068 48.5439 258.984 50.0561 257.374L65.1162 241.336C66.6284 239.726 66.5437 237.199 64.9846 235.634C63.319 233.962 61.7031 232.242 60.139 230.474C58.6749 228.82 56.1585 228.577 54.4564 229.985L37.5051 244.008Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 216,
    width: 32,
    height: 29
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7281 229.175C24.8629 230.359 24.3058 232.834 25.5389 234.667C27.5577 237.668 29.6843 240.595 31.9147 243.442C33.277 245.181 35.8029 245.416 37.5051 244.008L54.4564 229.985C56.1585 228.577 56.3912 226.059 55.0405 224.311C53.5976 222.444 52.2101 220.534 50.8798 218.585C49.6346 216.76 47.1686 216.203 45.3033 217.387L26.7281 229.175Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7281 229.175C24.8629 230.359 24.3058 232.834 25.5389 234.667C27.5577 237.668 29.6843 240.595 31.9147 243.442C33.277 245.181 35.8029 245.416 37.5051 244.008L54.4564 229.985C56.1585 228.577 56.3912 226.059 55.0405 224.311C53.5976 222.444 52.2101 220.534 50.8798 218.585C49.6346 216.76 47.1686 216.203 45.3033 217.387L26.7281 229.175Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 203,
    width: 33,
    height: 27
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8953 213.108C15.8964 214.049 15.0335 216.434 16.0271 218.407C17.6538 221.638 19.3969 224.808 21.2528 227.913C22.3864 229.809 24.8629 230.359 26.7281 229.175L45.3033 217.387C47.1686 216.203 47.7149 213.735 46.594 211.831C45.3966 209.797 44.2594 207.729 43.1839 205.628C42.1772 203.662 39.8004 202.8 37.8015 203.741L17.8953 213.108Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8953 213.108C15.8964 214.049 15.0335 216.434 16.0271 218.407C17.6538 221.638 19.3969 224.808 21.2528 227.913C22.3864 229.809 24.8629 230.359 26.7281 229.175L45.3033 217.387C47.1686 216.203 47.7149 213.735 46.594 211.831C45.3966 209.797 44.2594 207.729 43.1839 205.628C42.1772 203.662 39.8004 202.8 37.8015 203.741L17.8953 213.108Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 189,
    width: 33,
    height: 25
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1458 196.061C9.04474 196.743 7.88974 199.002 8.62817 201.084C9.83719 204.493 11.1691 207.857 12.6213 211.17C13.5083 213.193 15.8964 214.049 17.8953 213.108L37.8015 203.741C39.8004 202.8 40.6517 200.42 39.7783 198.391C38.8451 196.223 37.9762 194.028 37.1725 191.809C36.4202 189.732 34.17 188.58 32.069 189.262L11.1458 196.061Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1458 196.061C9.04474 196.743 7.88974 199.002 8.62817 201.084C9.83719 204.493 11.1691 207.857 12.6213 211.17C13.5083 213.193 15.8964 214.049 17.8953 213.108L37.8015 203.741C39.8004 202.8 40.6517 200.42 39.7783 198.391C38.8451 196.223 37.9762 194.028 37.1725 191.809C36.4202 189.732 34.17 188.58 32.069 189.262L11.1458 196.061Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 174,
    width: 32,
    height: 23
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58605 178.302C4.41604 178.716 2.98705 180.812 3.45873 182.97C4.23095 186.504 5.13073 190.008 6.1563 193.477C6.7827 195.595 9.04473 196.743 11.1458 196.061L32.069 189.262C34.17 188.58 35.313 186.325 34.7008 184.202C34.0467 181.935 33.4597 179.648 32.9404 177.346C32.4543 175.191 30.3664 173.766 28.1964 174.18L6.58605 178.302Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58605 178.302C4.41604 178.716 2.98705 180.812 3.45873 182.97C4.23095 186.504 5.13073 190.008 6.1563 193.477C6.7827 195.595 9.04473 196.743 11.1458 196.061L32.069 189.262C34.17 188.58 35.313 186.325 34.7008 184.202C34.0467 181.935 33.4597 179.648 32.9404 177.346C32.4543 175.191 30.3664 173.766 28.1964 174.18L6.58605 178.302Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 158,
    width: 32,
    height: 21
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28809 160.112C2.08331 160.25 0.402888 162.151 0.600337 164.351C0.92361 167.954 1.37711 171.543 1.95987 175.113C2.3158 177.293 4.41605 178.716 6.58606 178.302L28.1964 174.18C30.3664 173.766 31.783 171.672 31.4416 169.489C31.0769 167.157 30.781 164.816 30.5544 162.466C30.3423 160.267 28.4495 158.592 26.2447 158.73L4.28809 160.112Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28809 160.112C2.08331 160.25 0.402888 162.151 0.600337 164.351C0.92361 167.954 1.37711 171.543 1.95987 175.113C2.3158 177.293 4.41605 178.716 6.58606 178.302L28.1964 174.18C30.3664 173.766 31.783 171.672 31.4416 169.489C31.0769 167.157 30.781 164.816 30.5544 162.466C30.3423 160.267 28.4495 158.592 26.2447 158.73L4.28809 160.112Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 141,
    width: 31,
    height: 20
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2881 141.777C2.08332 141.638 0.177956 143.313 0.0980911 145.521C-0.0326767 149.135 -0.0326767 152.753 0.0980911 156.368C0.177956 158.576 2.08332 160.25 4.2881 160.112L26.2447 158.73C28.4495 158.592 30.1174 156.692 30.0522 154.484C29.9826 152.125 29.9826 149.764 30.0522 147.405C30.1174 145.197 28.4495 143.297 26.2447 143.158L4.2881 141.777Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2881 141.777C2.08332 141.638 0.177956 143.313 0.0980911 145.521C-0.0326767 149.135 -0.0326767 152.753 0.0980911 156.368C0.177956 158.576 2.08332 160.25 4.2881 160.112L26.2447 158.73C28.4495 158.592 30.1174 156.692 30.0522 154.484C29.9826 152.125 29.9826 149.764 30.0522 147.405C30.1174 145.197 28.4495 143.297 26.2447 143.158L4.2881 141.777Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 123,
    width: 32,
    height: 21
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58606 123.587C4.41605 123.173 2.3158 124.596 1.95987 126.776C1.37711 130.345 0.92361 133.935 0.600337 137.537C0.402888 139.738 2.08331 141.638 4.28809 141.777L26.2447 143.158C28.4495 143.297 30.3423 141.621 30.5544 139.422C30.781 137.073 31.0769 134.731 31.4416 132.399C31.783 130.217 30.3664 128.123 28.1964 127.709L6.58606 123.587Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58606 123.587C4.41605 123.173 2.3158 124.596 1.95987 126.776C1.37711 130.345 0.92361 133.935 0.600337 137.537C0.402888 139.738 2.08331 141.638 4.28809 141.777L26.2447 143.158C28.4495 143.297 30.3423 141.621 30.5544 139.422C30.781 137.073 31.0769 134.731 31.4416 132.399C31.783 130.217 30.3664 128.123 28.1964 127.709L6.58606 123.587Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 105,
    width: 32,
    height: 23
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1458 105.828C9.04473 105.145 6.7827 106.294 6.1563 108.412C5.13073 111.881 4.23095 115.385 3.45873 118.918C2.98705 121.077 4.41604 123.173 6.58605 123.587L28.1964 127.709C30.3664 128.123 32.4543 126.698 32.9404 124.543C33.4596 122.24 34.0467 119.954 34.7008 117.686C35.313 115.564 34.17 113.309 32.069 112.626L11.1458 105.828Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1458 105.828C9.04473 105.145 6.7827 106.294 6.1563 108.412C5.13073 111.881 4.23095 115.385 3.45873 118.918C2.98705 121.077 4.41604 123.173 6.58605 123.587L28.1964 127.709C30.3664 128.123 32.4543 126.698 32.9404 124.543C33.4596 122.24 34.0467 119.954 34.7008 117.686C35.313 115.564 34.17 113.309 32.069 112.626L11.1458 105.828Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 88,
    width: 33,
    height: 25
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8953 88.7806C15.8964 87.84 13.5082 88.6958 12.6213 90.719C11.1691 94.0316 9.83719 97.3956 8.62817 100.804C7.88974 102.887 9.04474 105.145 11.1458 105.828L32.069 112.626C34.17 113.309 36.4202 112.156 37.1725 110.079C37.9761 107.86 38.8451 105.666 39.7783 103.498C40.6517 101.469 39.8003 99.0883 37.8015 98.1477L17.8953 88.7806Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8953 88.7806C15.8964 87.84 13.5082 88.6958 12.6213 90.719C11.1691 94.0316 9.83719 97.3956 8.62817 100.804C7.88974 102.887 9.04474 105.145 11.1458 105.828L32.069 112.626C34.17 113.309 36.4202 112.156 37.1725 110.079C37.9761 107.86 38.8451 105.666 39.7783 103.498C40.6517 101.469 39.8003 99.0883 37.8015 98.1477L17.8953 88.7806Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 72,
    width: 33,
    height: 27
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7281 72.7136C24.8629 71.5299 22.3864 72.0797 21.2528 73.9758C19.3969 77.0803 17.6538 80.2508 16.0271 83.4813C15.0335 85.4544 15.8964 87.84 17.8952 88.7806L37.8015 98.1477C39.8003 99.0883 42.1772 98.227 43.1839 96.2606C44.2593 94.1598 45.3965 92.0912 46.594 90.0575C47.7149 88.1539 47.1686 85.6855 45.3033 84.5018L26.7281 72.7136Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7281 72.7136C24.8629 71.5299 22.3864 72.0797 21.2528 73.9758C19.3969 77.0803 17.6538 80.2508 16.0271 83.4813C15.0335 85.4544 15.8964 87.84 17.8952 88.7806L37.8015 98.1477C39.8003 99.0883 42.1772 98.227 43.1839 96.2606C44.2593 94.1598 45.3965 92.0912 46.594 90.0575C47.7149 88.1539 47.1686 85.6855 45.3033 84.5018L26.7281 72.7136Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 56,
    width: 32,
    height: 30
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5051 57.8804C35.8029 56.4723 33.277 56.7073 31.9147 58.4464C29.6843 61.2938 27.5577 64.2209 25.5389 67.222C24.3059 69.055 24.8629 71.5299 26.7281 72.7136L45.3033 84.5018C47.1686 85.6855 49.6346 85.1289 50.8798 83.3042C52.2101 81.3548 53.5976 79.445 55.0405 77.5774C56.3912 75.8293 56.1585 73.3119 54.4564 71.9038L37.5051 57.8804Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5051 57.8804C35.8029 56.4723 33.277 56.7073 31.9147 58.4464C29.6843 61.2938 27.5577 64.2209 25.5389 67.222C24.3059 69.055 24.8629 71.5299 26.7281 72.7136L45.3033 84.5018C47.1686 85.6855 49.6346 85.1289 50.8798 83.3042C52.2101 81.3548 53.5976 79.445 55.0405 77.5774C56.3912 75.8293 56.1585 73.3119 54.4564 71.9038L37.5051 57.8804Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 43,
    width: 31,
    height: 30
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0561 44.5149C48.5439 42.9045 46.0084 42.8211 44.4389 44.3758C41.8693 46.9212 39.3925 49.5586 37.0135 52.2831C35.5605 53.9471 35.8029 56.4723 37.5051 57.8804L54.4564 71.9038C56.1585 73.3119 58.6749 73.0688 60.139 71.4145C61.7031 69.6472 63.319 67.9264 64.9846 66.2544C66.5437 64.6893 66.6284 62.1626 65.1162 60.5522L50.0561 44.5149Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0561 44.5149C48.5439 42.9045 46.0084 42.8211 44.4389 44.3758C41.8693 46.9212 39.3925 49.5586 37.0135 52.2831C35.5605 53.9471 35.8029 56.4723 37.5051 57.8804L54.4564 71.9038C56.1585 73.3119 58.6749 73.0688 60.139 71.4145C61.7031 69.6472 63.319 67.9264 64.9846 66.2544C66.5437 64.6893 66.6284 62.1626 65.1162 60.5522L50.0561 44.5149Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 31,
    width: 30,
    height: 31
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1833 32.8279C62.8849 31.0406 60.3798 30.6401 58.6279 31.9858C55.7594 34.189 52.9717 36.4953 50.27 38.9001C48.6198 40.3688 48.5439 42.9045 50.0561 44.5149L65.1161 60.5522C66.6284 62.1626 69.1554 62.2368 70.8153 60.779C72.5886 59.2217 74.4074 57.717 76.2695 56.2669C78.0124 54.9096 78.4131 52.4135 77.1146 50.6262L64.1833 32.8279Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1833 32.8279C62.8849 31.0406 60.3798 30.6401 58.6279 31.9858C55.7594 34.189 52.9717 36.4953 50.27 38.9001C48.6198 40.3688 48.5439 42.9045 50.0561 44.5149L65.1161 60.5522C66.6284 62.1626 69.1554 62.2368 70.8153 60.779C72.5886 59.2217 74.4074 57.717 76.2695 56.2669C78.0124 54.9096 78.4131 52.4135 77.1146 50.6262L64.1833 32.8279Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 20,
    width: 28,
    height: 33
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M79.664 23.0036C78.5997 21.0677 76.1646 20.3564 74.2578 21.4719C71.1359 23.2982 68.081 25.2369 65.0992 27.2841C63.278 28.5345 62.8848 31.0406 64.1833 32.8279L77.1146 50.6262C78.4131 52.4135 80.9109 52.8037 82.7404 51.5655C84.6949 50.2427 86.688 48.9779 88.7171 47.7726C90.6164 46.6444 91.3268 44.2182 90.2625 42.2823L79.664 23.0036Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.664 23.0036C78.5997 21.0677 76.1646 20.3564 74.2578 21.4719C71.1359 23.2982 68.081 25.2369 65.0992 27.2841C63.278 28.5345 62.8848 31.0406 64.1833 32.8279L77.1146 50.6262C78.4131 52.4135 80.9109 52.8037 82.7404 51.5655C84.6949 50.2427 86.688 48.9779 88.7171 47.7726C90.6164 46.6444 91.3268 44.2182 90.2625 42.2823L79.664 23.0036Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 12,
    width: 26,
    height: 33
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2538 15.197C95.4406 13.143 93.1139 12.132 91.0823 12.9998C87.7561 14.4204 84.4823 15.961 81.2674 17.6183C79.3039 18.6306 78.5997 21.0677 79.664 23.0036L90.2625 42.2823C91.3268 44.2182 93.756 44.9185 95.7262 43.9193C97.8311 42.8519 99.967 41.8468 102.131 40.9054C104.157 40.0241 105.166 37.7061 104.353 35.652L96.2538 15.197Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2538 15.197C95.4406 13.143 93.1139 12.132 91.0823 12.9998C87.7561 14.4204 84.4823 15.961 81.2674 17.6183C79.3039 18.6306 78.5997 21.0677 79.664 23.0036L90.2625 42.2823C91.3268 44.2182 93.756 44.9185 95.7262 43.9193C97.8311 42.8519 99.967 41.8468 102.131 40.9054C104.157 40.0241 105.166 37.7061 104.353 35.652L96.2538 15.197Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 6,
    width: 25,
    height: 33
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M113.691 9.53118C113.142 7.39144 110.96 6.09691 108.836 6.70315C105.358 7.69573 101.917 8.81377 98.5196 10.0551C96.4447 10.8133 95.4406 13.143 96.2538 15.197L104.353 35.652C105.166 37.7061 107.488 38.7052 109.568 37.9609C111.79 37.1657 114.035 36.4363 116.3 35.7735C118.42 35.1531 119.712 32.9798 119.162 30.84L113.691 9.53118Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.691 9.53118C113.142 7.39144 110.96 6.09691 108.836 6.70315C105.358 7.69573 101.917 8.81377 98.5196 10.0551C96.4447 10.8133 95.4406 13.143 96.2538 15.197L104.353 35.652C105.166 37.7061 107.488 38.7052 109.568 37.9609C111.79 37.1657 114.035 36.4363 116.3 35.7735C118.42 35.1531 119.712 32.9798 119.162 30.84L113.691 9.53118Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 2,
    width: 22,
    height: 32
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M131.701 6.09558C131.424 3.90387 129.422 2.3461 127.239 2.6813C123.664 3.23016 120.11 3.90811 116.584 4.71387C114.43 5.20602 113.142 7.39145 113.691 9.53119L119.162 30.84C119.712 32.9798 121.891 34.2621 124.047 33.7843C126.352 33.2739 128.67 32.8316 131.001 32.4579C133.182 32.1082 134.736 30.1138 134.459 27.9221L131.701 6.09558Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.701 6.09558C131.424 3.90387 129.422 2.3461 127.239 2.6813C123.664 3.23016 120.11 3.90811 116.584 4.71387C114.43 5.20602 113.142 7.39145 113.691 9.53119L119.162 30.84C119.712 32.9798 121.891 34.2621 124.047 33.7843C126.352 33.2739 128.67 32.8316 131.001 32.4579C133.182 32.1082 134.736 30.1138 134.459 27.9221L131.701 6.09558Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 0,
    width: 19,
    height: 32
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M150 4.94435C150 2.73521 148.209 0.938756 146 0.997686C142.385 1.09413 138.774 1.3213 135.175 1.67878C132.976 1.8971 131.424 3.90388 131.701 6.09559L134.459 27.9221C134.736 30.1138 136.736 31.6591 138.936 31.4555C141.286 31.2379 143.642 31.0897 146.001 31.011C148.209 30.9374 150 29.1535 150 26.9443V4.94435Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 4.94435C150 2.73521 148.209 0.938756 146 0.997686C142.385 1.09413 138.774 1.3213 135.175 1.67878C132.976 1.8971 131.424 3.90388 131.701 6.09559L134.459 27.9221C134.736 30.1138 136.736 31.6591 138.936 31.4555C141.286 31.2379 143.642 31.0897 146.001 31.011C148.209 30.9374 150 29.1535 150 26.9443V4.94435Z",
    fill: "#E7EEEE",
    stroke: "white",
    strokeWidth: 4
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M115.073 152.588V165.385H113.368L106.926 155.515V165.385H105.229V152.588H106.926L113.395 162.484V152.588H115.073ZM117.402 160.735V160.533C117.402 159.848 117.502 159.212 117.701 158.626C117.9 158.034 118.188 157.521 118.562 157.088C118.938 156.648 119.392 156.309 119.925 156.068C120.458 155.822 121.056 155.699 121.718 155.699C122.386 155.699 122.986 155.822 123.52 156.068C124.059 156.309 124.516 156.648 124.891 157.088C125.271 157.521 125.562 158.034 125.761 158.626C125.96 159.212 126.06 159.848 126.06 160.533V160.735C126.06 161.421 125.96 162.057 125.761 162.643C125.562 163.229 125.271 163.741 124.891 164.181C124.516 164.614 124.062 164.954 123.528 165.2C123.001 165.44 122.403 165.561 121.735 165.561C121.067 165.561 120.467 165.44 119.934 165.2C119.4 164.954 118.943 164.614 118.562 164.181C118.188 163.741 117.9 163.229 117.701 162.643C117.502 162.057 117.402 161.421 117.402 160.735ZM119.028 160.533V160.735C119.028 161.21 119.084 161.658 119.195 162.08C119.307 162.496 119.474 162.865 119.696 163.188C119.925 163.51 120.209 163.765 120.549 163.952C120.889 164.134 121.284 164.225 121.735 164.225C122.181 164.225 122.57 164.134 122.904 163.952C123.244 163.765 123.525 163.51 123.748 163.188C123.971 162.865 124.138 162.496 124.249 162.08C124.366 161.658 124.425 161.21 124.425 160.735V160.533C124.425 160.064 124.366 159.622 124.249 159.206C124.138 158.784 123.968 158.412 123.739 158.09C123.517 157.762 123.235 157.504 122.896 157.316C122.562 157.129 122.169 157.035 121.718 157.035C121.272 157.035 120.88 157.129 120.54 157.316C120.206 157.504 119.925 157.762 119.696 158.09C119.474 158.412 119.307 158.784 119.195 159.206C119.084 159.622 119.028 160.064 119.028 160.533ZM138.558 163.539V151.885H140.192V165.385H138.698L138.558 163.539ZM132.159 160.735V160.551C132.159 159.824 132.247 159.165 132.423 158.573C132.604 157.976 132.859 157.463 133.188 157.035C133.521 156.607 133.917 156.279 134.374 156.051C134.837 155.816 135.353 155.699 135.921 155.699C136.519 155.699 137.04 155.805 137.485 156.016C137.937 156.221 138.317 156.522 138.628 156.921C138.944 157.313 139.193 157.788 139.375 158.345C139.557 158.901 139.683 159.531 139.753 160.234V161.043C139.688 161.74 139.562 162.367 139.375 162.924C139.193 163.48 138.944 163.955 138.628 164.348C138.317 164.74 137.937 165.042 137.485 165.253C137.034 165.458 136.507 165.561 135.903 165.561C135.347 165.561 134.837 165.44 134.374 165.2C133.917 164.96 133.521 164.623 133.188 164.189C132.859 163.756 132.604 163.246 132.423 162.66C132.247 162.068 132.159 161.427 132.159 160.735ZM133.794 160.551V160.735C133.794 161.21 133.841 161.655 133.935 162.071C134.034 162.487 134.187 162.854 134.392 163.17C134.597 163.486 134.857 163.735 135.174 163.917C135.49 164.093 135.868 164.181 136.308 164.181C136.847 164.181 137.289 164.066 137.635 163.838C137.986 163.609 138.268 163.308 138.479 162.933C138.689 162.558 138.854 162.15 138.971 161.711V159.593C138.9 159.271 138.798 158.96 138.663 158.661C138.534 158.356 138.364 158.087 138.153 157.853C137.948 157.612 137.693 157.422 137.389 157.281C137.09 157.141 136.735 157.07 136.325 157.07C135.88 157.07 135.496 157.164 135.174 157.352C134.857 157.533 134.597 157.785 134.392 158.107C134.187 158.424 134.034 158.793 133.935 159.215C133.841 159.631 133.794 160.076 133.794 160.551ZM148.331 163.759V158.863C148.331 158.488 148.255 158.163 148.103 157.888C147.956 157.606 147.733 157.39 147.435 157.237C147.136 157.085 146.767 157.009 146.327 157.009C145.917 157.009 145.557 157.079 145.246 157.22C144.941 157.36 144.701 157.545 144.525 157.773C144.355 158.002 144.271 158.248 144.271 158.512H142.645C142.645 158.172 142.732 157.835 142.908 157.501C143.084 157.167 143.336 156.865 143.664 156.596C143.998 156.32 144.396 156.104 144.859 155.945C145.328 155.781 145.85 155.699 146.424 155.699C147.115 155.699 147.725 155.816 148.252 156.051C148.785 156.285 149.201 156.64 149.5 157.114C149.805 157.583 149.957 158.172 149.957 158.881V163.311C149.957 163.627 149.983 163.964 150.036 164.321C150.095 164.679 150.18 164.986 150.291 165.244V165.385H148.595C148.513 165.197 148.448 164.948 148.401 164.638C148.354 164.321 148.331 164.028 148.331 163.759ZM148.612 159.619L148.63 160.762H146.986C146.523 160.762 146.11 160.8 145.747 160.876C145.384 160.946 145.079 161.055 144.833 161.201C144.587 161.348 144.399 161.532 144.271 161.755C144.142 161.972 144.077 162.227 144.077 162.52C144.077 162.818 144.145 163.091 144.279 163.337C144.414 163.583 144.616 163.779 144.886 163.926C145.161 164.066 145.498 164.137 145.896 164.137C146.395 164.137 146.834 164.031 147.215 163.82C147.596 163.609 147.897 163.352 148.12 163.047C148.349 162.742 148.472 162.446 148.489 162.159L149.184 162.941C149.143 163.188 149.031 163.46 148.85 163.759C148.668 164.058 148.425 164.345 148.12 164.62C147.821 164.89 147.464 165.115 147.048 165.297C146.638 165.473 146.175 165.561 145.659 165.561C145.015 165.561 144.449 165.435 143.963 165.183C143.482 164.931 143.107 164.594 142.838 164.172C142.574 163.744 142.442 163.267 142.442 162.739C142.442 162.229 142.542 161.781 142.741 161.395C142.94 161.002 143.228 160.677 143.603 160.419C143.978 160.155 144.429 159.956 144.956 159.821C145.483 159.687 146.072 159.619 146.723 159.619H148.612ZM156.496 155.875V157.123H151.354V155.875H156.496ZM153.095 153.563H154.721V163.029C154.721 163.352 154.771 163.595 154.87 163.759C154.97 163.923 155.099 164.031 155.257 164.084C155.415 164.137 155.585 164.163 155.767 164.163C155.901 164.163 156.042 164.151 156.188 164.128C156.341 164.099 156.455 164.075 156.531 164.058L156.54 165.385C156.411 165.426 156.241 165.464 156.03 165.499C155.825 165.54 155.576 165.561 155.283 165.561C154.885 165.561 154.519 165.481 154.185 165.323C153.851 165.165 153.584 164.901 153.385 164.532C153.191 164.157 153.095 163.653 153.095 163.021V153.563ZM164.011 163.759V158.863C164.011 158.488 163.935 158.163 163.782 157.888C163.636 157.606 163.413 157.39 163.114 157.237C162.815 157.085 162.446 157.009 162.007 157.009C161.597 157.009 161.236 157.079 160.926 157.22C160.621 157.36 160.381 157.545 160.205 157.773C160.035 158.002 159.95 158.248 159.95 158.512H158.324C158.324 158.172 158.412 157.835 158.588 157.501C158.764 157.167 159.016 156.865 159.344 156.596C159.678 156.32 160.076 156.104 160.539 155.945C161.008 155.781 161.529 155.699 162.104 155.699C162.795 155.699 163.404 155.816 163.932 156.051C164.465 156.285 164.881 156.64 165.18 157.114C165.484 157.583 165.637 158.172 165.637 158.881V163.311C165.637 163.627 165.663 163.964 165.716 164.321C165.774 164.679 165.859 164.986 165.971 165.244V165.385H164.274C164.192 165.197 164.128 164.948 164.081 164.638C164.034 164.321 164.011 164.028 164.011 163.759ZM164.292 159.619L164.31 160.762H162.666C162.203 160.762 161.79 160.8 161.427 160.876C161.063 160.946 160.759 161.055 160.513 161.201C160.267 161.348 160.079 161.532 159.95 161.755C159.821 161.972 159.757 162.227 159.757 162.52C159.757 162.818 159.824 163.091 159.959 163.337C160.094 163.583 160.296 163.779 160.565 163.926C160.841 164.066 161.178 164.137 161.576 164.137C162.074 164.137 162.514 164.031 162.895 163.82C163.275 163.609 163.577 163.352 163.8 163.047C164.028 162.742 164.151 162.446 164.169 162.159L164.863 162.941C164.822 163.188 164.711 163.46 164.529 163.759C164.348 164.058 164.104 164.345 163.8 164.62C163.501 164.89 163.144 165.115 162.728 165.297C162.317 165.473 161.854 165.561 161.339 165.561C160.694 165.561 160.129 165.435 159.643 165.183C159.162 164.931 158.787 164.594 158.518 164.172C158.254 163.744 158.122 163.267 158.122 162.739C158.122 162.229 158.222 161.781 158.421 161.395C158.62 161.002 158.907 160.677 159.282 160.419C159.657 160.155 160.108 159.956 160.636 159.821C161.163 159.687 161.752 159.619 162.402 159.619H164.292ZM175.331 164.4L177.977 155.875H179.717L175.902 166.853C175.814 167.087 175.697 167.339 175.551 167.608C175.41 167.884 175.229 168.145 175.006 168.391C174.783 168.637 174.514 168.836 174.197 168.988C173.887 169.146 173.515 169.226 173.081 169.226C172.952 169.226 172.788 169.208 172.589 169.173C172.39 169.138 172.249 169.108 172.167 169.085L172.158 167.767C172.205 167.772 172.278 167.778 172.378 167.784C172.483 167.796 172.557 167.802 172.598 167.802C172.967 167.802 173.28 167.752 173.538 167.652C173.796 167.559 174.013 167.397 174.188 167.169C174.37 166.946 174.525 166.639 174.654 166.246L175.331 164.4ZM173.389 155.875L175.858 163.258L176.28 164.972L175.111 165.569L171.613 155.875H173.389ZM185.008 165.561C184.346 165.561 183.745 165.449 183.206 165.227C182.673 164.998 182.213 164.679 181.826 164.269C181.445 163.858 181.152 163.372 180.947 162.81C180.742 162.247 180.64 161.632 180.64 160.964V160.595C180.64 159.821 180.754 159.133 180.982 158.529C181.211 157.92 181.521 157.404 181.914 156.982C182.307 156.561 182.752 156.241 183.25 156.024C183.748 155.808 184.264 155.699 184.797 155.699C185.477 155.699 186.062 155.816 186.555 156.051C187.053 156.285 187.46 156.613 187.776 157.035C188.093 157.451 188.327 157.943 188.479 158.512C188.632 159.074 188.708 159.689 188.708 160.357V161.087H181.606V159.76H187.082V159.637C187.059 159.215 186.971 158.805 186.818 158.406C186.672 158.008 186.438 157.68 186.115 157.422C185.793 157.164 185.354 157.035 184.797 157.035C184.428 157.035 184.088 157.114 183.777 157.272C183.467 157.425 183.2 157.653 182.978 157.958C182.755 158.263 182.582 158.635 182.459 159.074C182.336 159.514 182.274 160.021 182.274 160.595V160.964C182.274 161.415 182.336 161.84 182.459 162.238C182.588 162.631 182.772 162.977 183.013 163.275C183.259 163.574 183.555 163.809 183.9 163.979C184.252 164.148 184.65 164.233 185.096 164.233C185.67 164.233 186.156 164.116 186.555 163.882C186.953 163.647 187.302 163.334 187.601 162.941L188.585 163.724C188.38 164.034 188.119 164.33 187.803 164.611C187.486 164.893 187.097 165.121 186.634 165.297C186.177 165.473 185.635 165.561 185.008 165.561ZM194.588 155.875V157.123H189.446V155.875H194.588ZM191.187 153.563H192.812V163.029C192.812 163.352 192.862 163.595 192.962 163.759C193.062 163.923 193.19 164.031 193.349 164.084C193.507 164.137 193.677 164.163 193.858 164.163C193.993 164.163 194.134 164.151 194.28 164.128C194.433 164.099 194.547 164.075 194.623 164.058L194.632 165.385C194.503 165.426 194.333 165.464 194.122 165.499C193.917 165.54 193.668 165.561 193.375 165.561C192.977 165.561 192.61 165.481 192.276 165.323C191.942 165.165 191.676 164.901 191.477 164.532C191.283 164.157 191.187 163.653 191.187 163.021V153.563Z",
    fill: "#747474"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 122.238C158.145 122.131 157.377 123.223 153.935 125.27C148.225 128.67 146.816 127.752 144.666 130.416C140.241 135.681 142.367 140.895 148.351 143.405C155.709 146.524 163.897 142.478 166.274 134.236C166.748 132.427 167.786 128.473 165.491 125.31C164.88 124.443 164.091 123.719 163.178 123.189C162.265 122.659 161.249 122.334 160.2 122.238Z",
    fill: "#E7EEEE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M135.818 125.779L135.824 125.772C136.823 124.534 137.624 124.138 138.919 123.626C139.064 123.568 139.214 123.51 139.371 123.448C140.659 122.947 142.381 122.277 144.96 120.741C145.83 120.224 146.531 119.767 147.122 119.376C147.204 119.322 147.285 119.269 147.363 119.217C147.846 118.897 148.244 118.634 148.61 118.419C149.428 117.939 150.036 117.733 150.934 117.778C151.906 117.869 152.849 118.171 153.696 118.663C154.547 119.157 155.282 119.831 155.852 120.639L155.856 120.645C157.991 123.588 157.044 127.302 156.561 129.145C154.259 137.118 146.373 140.978 139.315 137.986L139.313 137.985C136.406 136.766 134.518 134.924 133.85 132.833C133.189 130.762 133.685 128.317 135.818 125.779Z",
    stroke: "#E7EEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 301,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPieChart);
export default __webpack_public_path__ + "static/media/empty_pie_chart.57ddde6085ed72d9055775f5cd86e923.svg";
export { ForwardRef as ReactComponent };